import { render } from "./company-hire.vue?vue&type=template&id=70c43dde"
import script from "./company-hire.vue?vue&type=script&lang=js"
export * from "./company-hire.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__